import { Settings } from '@mint-lib/icons';
import { Chip } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { PlatformCatalogItem } from '../../api/types.js';
import { Tooltip } from '../atoms/Tooltip.jsx';

type PlatformsListProps = Readonly<{
  platforms: PlatformCatalogItem[];
  disabled?: boolean;
  className?: string;
}>;

export default function PlatformsList({
  platforms,
  disabled,
  className,
}: PlatformsListProps) {
  const [chipPlatform, ...restPlatforms] = platforms;

  const platformChips = platforms.length > 2 ? [chipPlatform] : platforms;
  return (
    <div className={cn('flex gap-2', className)}>
      {platformChips.map(({ label, logo }) => (
        <Chip
          key={label}
          variant="outline"
          color="secondary"
          disabled={disabled}
        >
          {logo ? (
            <img src={logo} className="size-4" alt="" />
          ) : (
            <Settings className="size-4 fill-icon-primary" />
          )}
          {label}
        </Chip>
      ))}
      {platforms.length > 2 && (
        <Tooltip
          asChild
          description={restPlatforms
            .map((platform) => platform.label)
            .join(', ')}
        >
          <Chip variant="outline" color="info" disabled={disabled}>
            +{restPlatforms.length}
          </Chip>
        </Tooltip>
      )}
    </div>
  );
}
